import kitchen from './kitchen';

export default kitchen;
